export const GRADE_FILTERS = ["All Grades", "OPC 53", "OPC 43", "PPC", "PSC", "Composite"];

export const MARQUEE_ITEMS = [
  "Shree Cement",
  "Wonder Cement",
  "JSW Cement",
  "Ambuja Cement",
  "ACC Cement",
  "JK Super",
  "MP Birla Chetak",
  "Birla Uttam",
  "JK Lakshmi",
];

export const IS_TAGS = ["IS 12269", "IS 8112", "IS 1489 PPC", "IS 455 PSC"];

export const BRANDS = [
  {
    id: "shree",
    name: "Shree Cement",
    tag: "Bangur Power",
    grades: ["OPC 43", "PPC"],
    strength: "43 MPa+ @ 28 days",
    setting: "IST 40 min / FST 600 min",
    packaging: "50kg tamper-proof HDPE",
    applications: "Residential RCC, brickwork mortar, flooring",
  },
  {
    id: "wonder",
    name: "Wonder Cement",
    tag: "Ek Perfect Shuruaat",
    grades: ["OPC 53", "OPC 43", "PPC"],
    strength: "53 MPa+ @ 28 days",
    setting: "IST 30 min / FST 600 min",
    packaging: "50kg moisture-barrier HDPE",
    applications: "High-rise RCC, slabs, columns, plaster",
  },
  {
    id: "jsw",
    name: "JSW Cement",
    tag: "Strength of Steel & Slag",
    grades: ["PSC", "OPC 53", "Composite"],
    strength: "53 MPa+ @ 28 days",
    setting: "IST 35 min / FST 600 min",
    packaging: "50kg slag-tech bags",
    applications: "Marine, chemical-resistant, green projects",
  },
  {
    id: "ambuja",
    name: "Ambuja Cement",
    tag: "Giant Compressive Strength",
    grades: ["PPC", "OPC 53", "Composite"],
    strength: "53 MPa+ @ 28 days",
    setting: "IST 35 min / FST 600 min",
    packaging: "50kg moisture-barrier bags",
    applications: "Marine works, mass concrete, plastering",
  },
  {
    id: "acc",
    name: "ACC Cement",
    tag: "Legacy Since 1936",
    grades: ["OPC 53", "PPC", "PSC"],
    strength: "53 MPa+ @ 28 days",
    setting: "IST 30 min / FST 600 min",
    packaging: "50kg HDPE / paper bags",
    applications: "Bridges, dams, heavy RCC structures",
  },
  {
    id: "jksuper",
    name: "JK Super Cement",
    tag: "Build Strong",
    grades: ["OPC 43", "PPC"],
    strength: "43 MPa+ @ 28 days",
    setting: "IST 45 min / FST 600 min",
    packaging: "50kg HDPE bags",
    applications: "Housing projects, plaster, repair works",
  },
  {
    id: "mpbirla",
    name: "MP Birla Chetak",
    tag: "Cementing Bonds",
    grades: ["PPC", "OPC 43"],
    strength: "43 MPa+ @ 28 days",
    setting: "IST 40 min / FST 600 min",
    packaging: "50kg tamper-evident bags",
    applications: "Housing RCC, plaster, masonry works",
  },
  {
    id: "birlauttam",
    name: "Birla Uttam Cement",
    tag: "Uttam Quality, Trusted Name",
    grades: ["PPC", "OPC 43"],
    strength: "43 MPa+ @ 28 days",
    setting: "IST 40 min / FST 600 min",
    packaging: "50kg HDPE bags",
    applications: "Residential construction, flooring, repair",
  },
  {
    id: "jklakshmi",
    name: "JK Lakshmi Cement",
    tag: "Bharosa Har Banawat Ka",
    grades: ["OPC 53", "OPC 43", "PPC"],
    strength: "53 MPa+ @ 28 days",
    setting: "IST 30 min / FST 600 min",
    packaging: "50kg moisture-lock bags",
    applications: "High-rise RCC, precast, heavy foundations",
  },
];
